import { useContext } from 'react';
import {MessageContext} from "./messageContext";

export const useAlert = () => {
    const alert = useContext(MessageContext);
    return alert;
};

export * from './messageContext';
